var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1724_218214)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.1595,
    cy: 11.5194,
    r: 11.117,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6972 5.89819C20.5143 5.58856 20.1149 5.4859 19.8054 5.66864C19.4957 5.8515 19.393 6.25076 19.5758 6.56043C21.8403 10.3948 21.2196 15.2754 18.0665 18.4289C16.1815 20.3137 13.6801 21.2936 11.1533 21.2935C8.59693 21.2934 6.1151 20.2895 4.25582 18.4317C4.13779 18.3122 3.97399 18.2381 3.79277 18.2381C3.43316 18.2381 3.1416 18.5296 3.1416 18.8893V20.6384C3.1416 20.998 3.43312 21.2896 3.79277 21.2896C4.15243 21.2896 4.44394 20.9981 4.44394 20.6384V20.3223C6.38308 21.8056 8.73572 22.596 11.153 22.5959C14.0162 22.5958 16.8515 21.4853 18.9873 19.3498C22.5607 15.7759 23.2638 10.2444 20.6972 5.89819Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25284 4.61594C8.0539 0.815437 14.2286 0.781348 18.0634 4.61316C18.4685 5.0231 19.1777 4.74044 19.1777 4.15562V2.40647C19.1777 2.04686 18.8861 1.7553 18.5265 1.7553C18.1668 1.7553 17.8753 2.04682 17.8753 2.40647V2.72261C13.4601 -0.65479 7.24618 -0.218576 3.33195 3.69505C-0.241481 7.26895 -0.944632 12.8005 1.6221 17.1467C1.7436 17.3524 1.9606 17.4668 2.18338 17.4668C2.68104 17.4668 3.00156 16.9214 2.74348 16.4844C0.478998 12.65 1.09964 7.76948 4.25284 4.61594Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.16 11.5241C12.2389 11.5241 13.1135 10.6495 13.1135 9.57066C13.1135 8.49179 12.2389 7.61719 11.16 7.61719C10.0811 7.61719 9.20654 8.49179 9.20654 9.57066C9.20654 10.6495 10.0811 11.5241 11.16 11.5241Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1598 3.05859C6.4922 3.05859 2.69482 6.85597 2.69482 11.5236C2.69482 16.1911 6.4922 19.9885 11.1598 19.9885C15.8274 19.9885 19.6247 16.1911 19.6247 11.5236C19.6247 6.85597 15.8274 3.05859 11.1598 3.05859ZM16.0375 14.7213C15.7646 14.955 15.3535 14.9235 15.1194 14.6501C13.0369 12.2169 9.27979 12.2202 7.20013 14.6501C6.96637 14.9233 6.55534 14.9553 6.28202 14.7213C6.00878 14.4875 5.97691 14.0765 6.21076 13.8032C6.94557 12.9447 7.8784 12.3032 8.91297 11.9229C8.29203 11.3297 7.90402 10.4946 7.90402 9.57004C7.90402 7.77482 9.36452 6.31427 11.1598 6.31427C12.9551 6.31427 14.4156 7.77477 14.4156 9.57004C14.4156 10.4946 14.0275 11.3297 13.4066 11.9229C14.4412 12.3032 15.374 12.9447 16.1088 13.8032C16.3426 14.0765 16.3107 14.4875 16.0375 14.7213Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1724_218214"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.234,
    height: 22.234,
    fill: "white",
    transform: "translate(0.0424805 0.402344)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileEdit);
export default __webpack_public_path__ + "static/media/profile-edit.dfe72f4c68738c0e4eb48bef6629361b.svg";
export { ForwardRef as ReactComponent };